import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  PillarProgressIcon,
} from 'Views/Page/Content/Templates/ClientDashboardPageTemplate/Organisms/PillarProgress/PillarProgressIcon';

const useStyles = buildUseStyles('LockedPhase', (theme) => ({
  root: {
    position: 'relative',

    margin: `-${theme.spacing(1)}px`,
    padding: `${theme.spacing(1)}px`,
  },
  blur: {
    // Appear to be the same size as the content
    position: 'absolute',
    width: '100%',
    height: '100%',
    // Be on top of the content, even the step connector
    zIndex: 2,
    // Now that this is on top, when it blurs its backdrop, it's blurring the content
    backdropFilter: 'blur(5px)',

    margin: `-${theme.spacing(1)}px`,
  },
  lockIcon: {
    // Appear to be the same size as the content
    position: 'absolute',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    top: theme.spacing(3),
    // Be on top of the content, even the blur above
    zIndex: 3,
  },
}));

export function LockedPhase({ children }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.blur} />
      <div className={classes.lockIcon}>
        <PillarProgressIcon size="lg" />
      </div>
      {children}
    </div>
  );
}

LockedPhase.propTypes = {
  children: PropTypes.node.isRequired,
};
